module.exports = __webpack_public_path__ + "img/txl.e910284a.png";